import React from "react";

import Modal from "components/ui/modal/Modal";
import CentredSpinner from "lib/core_components/CentredSpinner";
import { SpendFilters } from "lib/hooks/api/spend/spendFilters";
import { useSpendTransactions } from "lib/hooks/api/spend/useSpendTransactions";
import ExportDataButton from "./ExportDataButton";
import { SpendChartError } from "./pageStates";
import TransactionsTable from "./TransactionsTable";

import css from "./TransactionsModal.module.scss";

type Props = { isOpen: boolean; onClose: () => void; filters: SpendFilters };

// TODO - this is a placeholder, need to know what data I can get from the chart i.e buyer / supplier names
function getFilterString(filters: SpendFilters) {
  const result: string[] = [];

  if (filters.buyerGuids?.length) {
    result.push(`Buyers`);
  }

  if (filters.buyerCountryCodes?.length || filters.buyerRegionIds?.length) {
    result.push(`Buyer HQ location`);
  }

  if (
    filters.supplierNames?.length ||
    filters.supplierGuids?.length ||
    filters.supplierNamesExact?.length
  ) {
    result.push(`Suppliers`);
  }

  if (filters.dateFrom || filters.dateTo) {
    const datefrom = filters.dateFrom ? new Date(filters.dateFrom) : undefined;
    const dateTo = filters.dateTo ? new Date(filters.dateTo) : undefined;
    result.push(`Dates ${datefrom?.toLocaleDateString()} - ${dateTo?.toLocaleDateString()}`);
  }

  if (result.length === 0) {
    return undefined;
  }

  return `Filtered by ${result.join(" • ")}`;
}

export function TransactionsModal({ isOpen, onClose, filters }: Props) {
  const { data, isLoading, isError, error, refetch } = useSpendTransactions({
    filters,
    limit: 10,
    offset: 0,
  });
  const filterString = getFilterString(filters);

  let body: React.ReactNode;
  if (isError) {
    body = <SpendChartError error={error} onRetry={refetch} />;
  } else if (isLoading) {
    body = <CentredSpinner />;
  } else {
    body = (
      <div className={css.modal}>
        <div className={css.modalHeader}>
          <h3>Detailed View</h3>
          <h4>{data?.totalResults} Transactions</h4>
          {filterString && <p>{filterString}</p>}
          <ExportDataButton
            className={css.export}
            filters={filters}
            totalRows={data?.totalResults}
          />
        </div>
        <TransactionsTable filters={filters} className={css.table} />
      </div>
    );
  }

  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      width="1000px"
    >
      {body}
    </Modal>
  );
}
